import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { shouldUpdateCodeState } from 'state/atoms';

const useUpdateCode = () => {
  const [showBlur, setShowBlur] = useState(false);
  const globalShouldUpdateCode = useRecoilValue(shouldUpdateCodeState);

  const onCloseBlur = () => {
    setShowBlur(false);
  };

  useEffect(() => {
    setShowBlur(globalShouldUpdateCode);
  }, [globalShouldUpdateCode, setShowBlur]);

  return {
    showBlur,
    onCloseBlur,
  };
};

export default useUpdateCode;
